import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TourneyPlannerPage from './pages/TourneyPlannerPage';
import MembersAreaPage from './pages/MembersAreaPage';
import ToolkitPage from './pages/ToolkitPage';
import ParkPage from './pages/ParkPage';
import { AuthProvider } from './contexts/AuthContext';
import { ToolkitProvider } from './contexts/ToolkitContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#89479a',
    },
    secondary: {
      main: '#f78f29',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 600,
    },
  },
});

function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = (open) => {
    setDrawerOpen(open);
  };

  return (
    <AuthProvider>
      <ToolkitProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
            <Router>
              <Header onDrawerToggle={handleDrawerToggle} />
              <Sidebar open={drawerOpen} onDrawerToggle={handleDrawerToggle} />
              <Routes>
                <Route path="/" element={process.env.REACT_APP_PARKED !== 'false' ? <ParkPage /> : <HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/tourney-planner" element={<TourneyPlannerPage />} />
                <Route path="/members" element={<MembersAreaPage />} />
                <Route path="/toolkit" element={<ToolkitPage />} />
              </Routes>
            </Router>
        </ThemeProvider>
      </ToolkitProvider>
    </AuthProvider>
  );
}

export default App;
